module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyItalic.woff?3be553fc3b6e40767311f46dc357d19d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyItalic.woff
// module id = 1413
// module chunks = 0